import React from 'react';
import CustomModal from './index';
import PropTypes from 'prop-types';

const ModalClose = ({ title, close, children, size = 'lg' }) => {
  const buttons = [
    {
      title: 'Cerrar',
      className: 'btn btn-secondary text-center',
      action: close,
    },
  ];

  return (
    <CustomModal title={title} show={true} close={close} buttons={buttons} size={size}>
      <div className='d-flex justify-content-center p-4 text-center'>{children}</div>
    </CustomModal>
  );
};

ModalClose.proptypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ModalClose;
